export const COOKIES_NAME = 'samokat-opora';
